import React from 'react';

const SimpleResponsiveTest: React.FC = () => {
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#f0f0f0', 
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>
        🧪 Simple Responsive Test
      </h1>
      
      <div style={{
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <h2>✅ Page Loaded Successfully!</h2>
        <p>If you can see this, the routing is working correctly.</p>
        
        <div style={{ marginTop: '20px' }}>
          <h3>Viewport Information:</h3>
          <div id="viewport-info" style={{
            padding: '10px',
            backgroundColor: '#e3f2fd',
            borderRadius: '4px',
            fontFamily: 'monospace'
          }}>
            Loading...
          </div>
        </div>
        
        <div style={{ marginTop: '20px' }}>
          <h3>Responsive Test:</h3>
          <div className="mobile-only" style={{
            padding: '10px',
            backgroundColor: '#ffebee',
            borderRadius: '4px',
            margin: '10px 0'
          }}>
            {"📱 Mobile/Tablet View (shows when width < 1024px)"}
          </div>
          
          <div className="desktop-only" style={{
            display: 'none',
            padding: '10px',
            backgroundColor: '#e8f5e8',
            borderRadius: '4px',
            margin: '10px 0'
          }}>
            💻 Desktop View (shows when width ≥ 1024px)
          </div>
        </div>
      </div>

 
        <style>{`
          @media (min-width: 1024px) {
            .mobile-only {
              display: none !important;
            }
            .desktop-only {
              display: block !important;
            }
          }
        `}</style>

      <script dangerouslySetInnerHTML={{
        __html: `
          setTimeout(() => {
            function updateViewport() {
              const info = document.getElementById('viewport-info');
              if (info) {
                const width = window.innerWidth;
                const height = window.innerHeight;
                const type = width < 768 ? 'Mobile' : width < 1024 ? 'Tablet' : 'Desktop';
                info.textContent = width + 'x' + height + ' pixels (' + type + ')';
              }
            }
            
            updateViewport();
            window.addEventListener('resize', updateViewport);
          }, 100);
        `
      }} />
    </div>
  );
};

export default SimpleResponsiveTest;
